/* global TimelineMax TweenMax Quad */
import React, { Component } from 'react';
import ReactScene from 'react-scene';
import PropTypes from 'prop-types';

import { loadTextures, clearTextures } from '../../lib/loadTextures';
import Scene from '../views/Scene.jsx';

import createSprite from '../../lib/createSprite';
import spritesHelper from '../../lib/spritesHelper';
import Utils from '../../lib/utils';

import Audio from '../../lib/audio';

import CommonAnimations from '../../animations/common';

// Scene data
import OligarchieObjects from '../../objects/oligarchie';
// import StartFrame from '../frames/_common/StartFrame.jsx';

// Frames
// import Title from '../frames/E-Oligarchie/1-Title';
import TrioFunnel from '../frames/E-Oligarchie/2-TrioFunnel.jsx';
import PuppetsMaster from '../frames/E-Oligarchie/3-PuppetsMaster.jsx';
import Painters from '../frames/E-Oligarchie/4-Painters.jsx';
// import VacuumLeft from '../frames/E-Oligarchie/5-VacuumLeft';
// import VacuumRight from '../frames/E-Oligarchie/6-VacuumRight';
import BucketGuards from '../frames/E-Oligarchie/7-BucketGuards.jsx';
import EndFrame from '../frames/E-Oligarchie/8-EndFrame.jsx';

import Brett from '../frames/C-TooBig/2-SlotMachineBig.jsx';
import Regulateur from '../frames/D-Regulation/4-SoloFunnel.jsx';
import Family from '../frames/A-Remuneration/3-FamilyPump.jsx';

import GuillotineAnimations from '../../animations/guillotine';

const propTypes = {
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,

    frameWidth: PropTypes.number,
    frameHeight: PropTypes.number,

    storiesContainer: PropTypes.object,

    mouseDown: PropTypes.bool,
    mouseMove: PropTypes.bool,
    mouseClientX: PropTypes.number,
    mouseClientY: PropTypes.number,
    mouseWheelX: PropTypes.number,
    mouseWheelY: PropTypes.number,
};

const defaultProps = {
    framesClasses: [BucketGuards, Regulateur, Brett, TrioFunnel, Painters, PuppetsMaster, Family, BucketGuards, EndFrame],
    framesRenderExceptions: {
        // '4': [5, 6]
    },
    framesTransitions: {
        // 5: true
    },
    audioUrls: {
        buttonPress: '/audio/28nov/oligarchie-bouton.mp3',
    },
};

const contextTypes = {
    intensity: PropTypes.number,
    minIntensity: PropTypes.number,
    maxIntensity: PropTypes.number,
};

class Oligarchie extends Component {

    constructor(props, context) {
        super(props, context);

        this.mainTimeline = null;
        this.guillotineTimeline = null;
        this.sprites = null;
        this.handPressButtonAnimations = null;
        this.buttonPressedCount = null;
        this.audios = null;

        this.onButtonPressed = this.onButtonPressed.bind(this);
        this.onTextureLoaded = this.onTextureLoaded.bind(this);
        this.onFrameIndexChanged = this.onFrameIndexChanged.bind(this);
        this.onHandButtonPressFrameUpdate = this.onHandButtonPressFrameUpdate.bind(this);

        this.build = this.build.bind(this);
        this.load = this.load.bind(this);
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);

        this.state = {
            objectsWithTextures: null,
            mainContainer: null,
            frameIndex: 0,
            intensity: context.intensity,
            loadedProgress: 0,
        };
    }

    render() {
        const {
            intensity,
            mainContainer,
            objectsWithTextures,
            loadedProgress,
        } = this.state;

        return (
            <Scene
                intensity={intensity}
                mainContainer={mainContainer}
                objectsWithTextures={objectsWithTextures}
                onFrameIndexChanged={this.onFrameIndexChanged}
                loadedProgress={loadedProgress}
                {...this.props}
            />
        );
    }

    /*
     * React life cycle
     */

    componentDidMount() {
        this.mainTimeline = new TimelineMax({
            paused: true,
        });
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const intensityChanged = prevContext.intensity !== this.context.intensity;

        if (intensityChanged) {
            this.updateIntensity(prevContext.intensity);
        }
    }

    componentWillUnmount() {
        if (this.mainTimeline) {
            this.mainTimeline.pause();
            this.mainTimeline.kill();
            this.mainTimeline = null;
        }
    }

    /*
     * Scene life cycle
     */

    load(e) {
        var done = e.async();

        var onTexturesLoaded = _.bind(function(objectsWithTextures)
        {
            this.setState({
                objectsWithTextures: objectsWithTextures
            }, done)
        }, this);

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            this.audios[key] = new Audio(value);
        }, this));

        clearTextures(Object.keys(OligarchieObjects));

        loadTextures(OligarchieObjects, this.onTextureLoaded)
            .then(onTexturesLoaded);
    }

    build(e)
    {
        var mainContainer = new PIXI.Container();
        this.props.storiesContainer.addChild(mainContainer);
        this.sprites = {};

        this.setState({
            mainContainer: mainContainer
        }, function(){
            this.buildObjects();
            this.animateObjects();
            this.updateIntensity(this.context.intensity);
            this.onButtonPressed();
        });
    }

    resize(e)
    {

    }

    mute(e)
    {

    }

    unmute(e)
    {

    }

    play(e)
    {
        if (this.mainTimeline)
        {
            this.mainTimeline.play();
        }
    }

    pause(e)
    {
        if (this.mainTimeline)
        {
            this.mainTimeline.pause();
        }
    }

    end(e)
    {

    }

    destroy(e)
    {

    }

    /*
     * Methods
     */

    buildObjects()
    {
        var sprites = this.sprites;
        var state = this.state;
        var container = state.mainContainer;

        // buttons
        var handPressButtons = sprites.handPressButtons = this.createHandPressButtons();
        var sprite;
        for (var i = 0, il = handPressButtons.length; i < il; i++)
        {
            sprite = _.get(handPressButtons[i], 'sprite', null);
            sprite.visible = false;
            sprite.alpha = 0;
            if (sprite)
            {
                container.addChild(sprite);
            }
        }

        // z-index reorder
        container.setChildIndex(container.getChildByName('background5'), 0);

        this.buildGuillotine();
    }

    buildGuillotine() {
        // const { mainContainer, objectsWithTextures } = this.state;
        // const sprites = this.sprites;
        // const objs = objectsWithTextures;
        //
        // const frame6 = mainContainer.getChildByName('frame6');
        // const background6 = mainContainer.getChildByName('background6');
        //
        // const frame7 = mainContainer.getChildByName('frame7');
        // const background7 = mainContainer.getChildByName('background7');
        // const ropeObj = objs.rope;
        //
        // // guillotine
        // const guillotineObj = objs.guillotine;
        // sprites.guillotine = createSprite(guillotineObj);
        // const guillotine = sprites.guillotine;
        // Utils.setSizeAndPositionFromRefSprite(guillotine, background6, guillotineObj);
        //
        // // wheel left
        // const wheelObj = objs.wheel;
        // sprites.wheelLeft = createSprite(wheelObj);
        // const wheelLeft = sprites.wheelLeft;
        // Utils.setSizeAndPositionFromRefSprite(wheelLeft, background6, wheelObj);
        //
        // // rope left
        // sprites.ropeLeft = spritesHelper.buildRope(ropeObj, frame6, background6, ropeObj.left);
        // const ropeLeft = sprites.ropeLeft;
        //
        // mainContainer.addChild(guillotine);
        // mainContainer.addChild(wheelLeft);
        // // mainContainer.addChild(ropeLeft);
        // frame6.addChild(ropeLeft);
    }

    createHandPressButtons()
    {
        var props = this.props;
        var width = props.frameWidth;
        var height = props.frameHeight;
        var container = this.state.mainContainer;
        var objs = this.state.objectsWithTextures;

        var handPressButtonObj = objs.handPressButton;
        var buttons = [];
        _.forOwn(_.get(handPressButtonObj, 'frames'), _.bind(function(frame, frameKey) {
            var refSprite = container.getChildByName('background'+frameKey); // TMP
            if (refSprite)
            {
                buttons.push({
                    frameKey: frameKey,
                    sprite: this.createHandPressButton(refSprite, frame)
                });
            }
        }, this));

        return buttons;
    }

    createHandPressButton(refSprite, opts)
    {
        var objs = this.state.objectsWithTextures;

        var container = new PIXI.Container();

        var buttonBgObj = objs.buttonBg;
        var buttonBg = createSprite(buttonBgObj);
        Utils.setSizeAndPositionFromRefSprite(buttonBg, refSprite, _.merge(buttonBgObj, opts));

        var handPressButtonObj = objs.handPressButton;
        var handPressButton = createSprite(handPressButtonObj);
        Utils.setSizeAndPositionFromRefSprite(handPressButton, refSprite, _.merge(handPressButtonObj, opts));

        handPressButton.name = 'movieclip';

        container.addChild(buttonBg);
        container.addChild(handPressButton);

        return container;
    }

    animateObjects()
    {
        var sprites = this.sprites;
        // hands press button
        var handPressButtonsMovieclipOptions = {
            fps: 5,
            repeat: 0
        };
        var handPressButtonFrameKey, handPressButtonSprite, handPressButtonMovieclip;
        this.handPressButtonAnimations = {};
        for (var i = 0, il = sprites.handPressButtons.length; i < il; i++)
        {
            handPressButtonFrameKey = _.get(sprites.handPressButtons[i], 'frameKey', null);
            handPressButtonSprite = _.get(sprites.handPressButtons[i], 'sprite', null);
            handPressButtonMovieclip = handPressButtonSprite.getChildByName('movieclip');
            if (handPressButtonMovieclip)
            {
                this.handPressButtonAnimations[handPressButtonFrameKey] = CommonAnimations.getMovieclipTimeline(handPressButtonMovieclip, _.extend({
                    onFrameUpdate: this.onHandButtonPressFrameUpdate
                }, handPressButtonsMovieclipOptions));
                this.handPressButtonAnimations[handPressButtonFrameKey].pause();
            }
        }

        this.animateGuillotine();
    }

    animateGuillotine() {
        // const { mainContainer } = this.state;
        // const sprites = this.sprites;
        //
        // const wheelLeft = sprites.wheelLeft;
        // const guillotine = sprites.guillotine;
        // const ropeLeft = sprites.ropeLeft;
        // // const ropeTop = sprites.ropeTop;
        // const background1 = mainContainer.getChildByName('background1');
        // const ropePixels = background1.height * 0.05;
        //
        // this.guillotineTimeline = GuillotineAnimations.getGuillotineTimeline({
        //     leftElements: [ropeLeft, guillotine],
        //     topElements: null,
        //     rightElements: null,
        //     wheels: wheelLeft,
        //     pixels: ropePixels,
        //     rotation: -15,
        // });
        //
        // this.mainTimeline.add(this.guillotineTimeline);
        // this.mainTimeline.pause();
        // this.mainTimeline.play(); // devrait être callé par le play, après le build... hmm
    }

    updateIntensity(prevIntensity) {
        var frameIndex = this.state.frameIndex;
        var intensity = this.context.intensity;
        var props = this.props;

        if (prevIntensity !== intensity) {
            var handPressButtonSprite = this.getHandPressButtonSpriteFromIndex(frameIndex);
            var handPressButtonAnimation = _.get(this.handPressButtonAnimations, frameIndex, null);
            if (handPressButtonSprite) {
                TweenMax.killTweensOf(handPressButtonSprite);
                TweenMax.to(handPressButtonSprite, 0.4, {
                    alpha: 1
                });
            }

            if (handPressButtonAnimation) {
                this.buttonPressedCount = 0;
                handPressButtonAnimation.progress(0);
                handPressButtonAnimation.play();
            }

            this.updateGuillotineIntensity();
        }
    }

    updateGuillotineIntensity() {
        // const { intensity, minIntensity, maxIntensity } = this.context;
        //
        // if (this.guillotineTimeline) {
        //     this.guillotineTimeline.pause();
        //     const timeline = new TimelineMax();
        //     const progress = ((intensity - minIntensity) * 0.8) / (maxIntensity - minIntensity);
        //
        //     TweenMax.killTweensOf(this.guillotineTimeline);
        //
        //     timeline.to(this.guillotineTimeline, 2, {
        //         progress,
        //         ease: Quad.easeOut,
        //     });
        //     timeline.to(this.guillotineTimeline, 1, {
        //         repeat: -1,
        //         yoyo: true,
        //         progress: '+=0.2',
        //         ease: Quad.easeInOut,
        //     });
        // }
    }

    getHandPressButtonSpriteFromIndex(index)
    {
        var handPressButtons = this.sprites.handPressButtons;

        return _.get(_.find(handPressButtons, function(buttonObject){
            return buttonObject.frameKey === index+'';
        }, null), 'sprite', null);
    }

    /*
     * Event handlers
     */

    onFrameIndexChanged(frameIndex)
    {
        var lastHandPressButtonSprite = this.getHandPressButtonSpriteFromIndex(this.state.frameIndex);
        var handPressButtonSprite = this.getHandPressButtonSpriteFromIndex(frameIndex);

        this.setState({
            frameIndex: frameIndex
        }, function(){
            if (lastHandPressButtonSprite)
            {
                TweenMax.killTweensOf(lastHandPressButtonSprite);
                TweenMax.to(lastHandPressButtonSprite, 0.4, {
                    alpha: 0,
                    visible: false
                });
            }
            if (handPressButtonSprite)
            {
                TweenMax.killTweensOf(handPressButtonSprite);
                handPressButtonSprite.visible = true;
                handPressButtonSprite.alpha = 0;
            }
        });
    }

    onHandButtonPressFrameUpdate(movieclip)
    {
        var frameIndex = this.state.frameIndex;
        var currentFrame = movieclip.currentFrame;
        var isButtonPressed = currentFrame === 6;
        var nowPaused = currentFrame === 0;
        var buttonPressAudio = this.audios.buttonPress;

        if(isButtonPressed) // pressed button
        {
            var handPressButtonAnimation = _.get(this.handPressButtonAnimations, frameIndex, null);
            var context = this.context;
            var intensity = context.intensity;
            var maxIntensity = context.maxIntensity;
            this.buttonPressedCount++;
            if (intensity === 1)
            {
                buttonPressAudio.play(0);
                setTimeout(this.onButtonPressed, 100);
            } else {
                buttonPressAudio.play(0);
                if (handPressButtonAnimation)
                {
                    handPressButtonAnimation.pause();
                }

                var timeline = new TimelineMax({
                    onComplete: _.bind(function(){
                        setTimeout(this.onButtonPressed, 100);
                        buttonPressAudio.play(0);
                        if (handPressButtonAnimation)
                        {
                            handPressButtonAnimation.play();
                        }
                    }, this)
                });
                var frameDelay = 0.2 - 0.03 * Math.min(intensity, 3);
                for (var i = 0; i < intensity-1;i++)
                {
                    timeline.set({}, {
                        delay:frameDelay,
                        onComplete: () => {
                            movieclip.gotoAndStop(currentFrame-1);
                        }
                    });
                    timeline.set({}, {
                        delay:frameDelay,
                        onComplete: () => {
                            buttonPressAudio.play(0);
                            movieclip.gotoAndStop(currentFrame);
                        }
                    });
                }
            }
        }

        if (nowPaused)
        {
            var handPressButtonSprite = this.getHandPressButtonSpriteFromIndex(frameIndex);
            if (handPressButtonSprite)
            {
                TweenMax.to(handPressButtonSprite, 0.4, {
                    delay: 2,
                    alpha: 0,
                    visible: false,
                });
            }
        }
    }

    onButtonPressed() {
        this.setState({
            intensity: this.context.intensity,
        });
    }

    onTextureLoaded(data) {
        this.setState({
            loadedProgress: data.progress,
        });
    }
}

Oligarchie.propTypes = propTypes;
Oligarchie.defaultProps = defaultProps;
Oligarchie.contextTypes = contextTypes;

module.exports = ReactScene.createScene(Oligarchie);



// WEBPACK FOOTER //
// ./js/components/scenes/E-Oligarchie.jsx